export enum AssociationFeatureFlagEnum {
  HIDE_COACH_CLASS = "HIDE_COACH_CLASS",
}
